import styled from 'styled-components';

const FormLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme?.formLayout?.gap || '20px'};
`;

export default FormLayout;
